import React, {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';
import {t} from '../../util/i18n';

const FileDrop = ( {id, onFileAdded} ) => {
    const onDrop = useCallback( acceptedFiles => {
        acceptedFiles.forEach( ( file ) => {
            const reader = new FileReader()

            reader.onabort = () => console.warn( 'file reading was aborted' );
            reader.onerror = err => console.error( '[ReadFile Failed]', err );
            reader.onload = () => {

                const base64Str = reader.result
                onFileAdded( {
                    fileName: file.name,
                    data: base64Str
                } );
            }
            // reader.readAsArrayBuffer( file )
            reader.readAsDataURL( file );
        } )
    }, [] )
    const {getRootProps, getInputProps, isDragActive} = useDropzone( {onDrop} );

    return (
        <div {...getRootProps()}
             className="text-center text-title text-grey-dark p-6 bg-near-white border-2 border-dashed border-grey-lighter rounded-lg">
            <input id={id} name={id} {...getInputProps()} />
            {
                isDragActive ?
                    <p className="text-blue">
                        {t( 'fileDrop.actionLabel.dropHere', 'Drop files here...' )}
                    </p> :
                    <p className="hover:link-2-underline">
                        {t( 'fileDrop.actionLabel.dragAndDropFiles', 'Drag and drop files here, or browse' )}
                    </p>
            }
        </div>

    )
}

export const FileAttachment = ( {fileName, onRemove} ) =>
    <div className="flex items-center bg-near-white rounded-lg mb-2 px-4 py-2">
        <span className="flex-auto">{fileName}</span>
        <div onClick={onRemove} className="h-8 w-4 text-2xl leading-none hover:text-fail cursor-pointer">&times;</div>
    </div>
;

export default FileDrop;
